/**
 * Microsoft Teams integration documentation page
 */

import {DocsContent} from '../../../components/docs/DocsContent';
import {DocsActionButtons} from '../../../components/docs/DocsActionButtons';

export function TeamsIntegration() {
  return (
    <DocsContent
      title="Microsoft Teams Integration"
      description="Connect VoxaPilot with Microsoft Teams to automatically transcribe your meetings."
    >
      <div className="space-y-8">
        <section>
          <h2 className="text-2xl font-bold text-textPrimary mb-4">Overview</h2>
          <p className="text-textSecondary mb-4">
            VoxaPilot integrates with Microsoft Teams to automatically record and transcribe your
            meetings. Perfect for organizations using Microsoft 365.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-textPrimary mb-4">Setup</h2>
          <p className="text-textSecondary mb-4">
            Connect your Microsoft Teams account through the integrations page. Enterprise customers
            can set up organization-wide integration with SSO.
          </p>
        </section>

        <DocsActionButtons pageTitle="Microsoft Teams Integration" />
      </div>
    </DocsContent>
  );
}

